module.exports = __webpack_public_path__ + "7884e6856512fef38531edaa5c879f3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 426
// module chunks = 0